import { module } from 'angular';
import { TerraformStageConfig } from './TerraformStageConfig'
import { TerraformExecutionDetails } from './TerraformExecutionDetails';
import { TerraformMarkerIcon } from './TerraformMarkerIcon';
import {
  Registry,
  ExecutionArtifactTab,
  ExecutionDetailsTasks,
  SETTINGS,
} from '@spinnaker/core';

export const TERRAFORM_STAGE = 'spinnaker.terraform.stage';

module(TERRAFORM_STAGE, []);

if (SETTINGS.feature.terraform) {
  Registry.pipeline.registerStage({
    label: 'Terraform',
    description: 'Apply a terraform operation',
    key: 'terraform',
    component: TerraformStageConfig,
    executionDetailsSections: [TerraformExecutionDetails, ExecutionDetailsTasks, ExecutionArtifactTab],
    producesArtifacts: true,
    supportsCustomTimeout: true,
    markerIcon: TerraformMarkerIcon,
  });
}
